import type { PropsWithChildren, ReactNode } from 'react'
import { StandaloneBadge, StyledMuiBadge } from './Badge.styled'

export enum BadgeStatus {
  NEW = 'new',
  COUNT = 'count',
}

export type BadgeProps = PropsWithChildren<
  | {
      /** A bare dot: no content, only the status drives its colour. */
      size?: 'xs'
      status?: BadgeStatus
      content?: never
    }
  | {
      size?: 's' | 'm'
      status: BadgeStatus
      content?: ReactNode
    }
>

export const Badge = ({
  size = 'm',
  children,
  content,
  status,
}: BadgeProps) => {
  if (!children) {
    return (
      <StandaloneBadge className={`size-${size} status-${status}`}>
        {size !== 'xs' && content}
      </StandaloneBadge>
    )
  }

  return (
    <StyledMuiBadge
      variant={size === 'xs' ? 'dot' : 'standard'}
      badgeContent={content}
      slotProps={{ badge: { className: `size-${size} status-${status}` } }}
    >
      {children}
    </StyledMuiBadge>
  )
}
